import { isPathEk } from '@/utils/routes';
import ApiService from './ApiService';
import { COMMON_TYPE } from '@/types/enums';

export default class UserApi extends ApiService {
    // constructor() {
    //     super('system');
    // }

    getAccountsPagination(payload) {
        return this.get('system/users/pagination', payload);
    }

    getAccounts(payload) {
        return this.get('system/users', payload);
    }

    getAccount({ id }) {
        return this.get(`system/users/${id}`);
    }

    createAccount(payload) {
        return this.post('system/users', payload);
    }

    editAccount(payload) {
        const { id, data } = payload;
        return this.put(`system/users/${id}`, data);
    }

    deleteAccount(accountId) {
        return this.delete(`system/users/${accountId}`);
    }

    uploadOCR(payload) {
        const type = isPathEk(window.location.pathname) ?
            COMMON_TYPE.EK :
            COMMON_TYPE.GAS;
        return this.post(`system/users/ocr-license?type=${type}`, payload, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    getListFavoriteLocationsByStatus(payload) {
        return this.get('customer/favorite-locations', payload);
    }

    registerFavoriteLocation(payload) {
        return this.post('customer/favorite-locations', payload);
    }

    unregisterFavoriteLocation(payload) {
        return this.post('customer/unregister/favorite-locations', payload);
    }

    registerCoupon(payload) {
        return this.put('system/coupon-register', payload);
    }

    getRegistedCouponList() {
        return this.get('system/coupon-registed-list');
    }

    getHisoryChangeUser(payload) {
        const { userId, ...rest } = payload;
        return this.get(`system/users/change-history/${userId}`, rest);
    }
}
